import { Trans } from '@lingui/react/macro';
import { Box } from '@pocketlaw/tetris';
import { useField } from 'formik';
import { useCompanyFeatures } from 'app/domains/companies';
import { AssistantChatKind } from 'shared/domains/apollo/generated/types';
import { ToggleTabs, ToggleTabsButton, ToggleTabsButtonsContainer } from 'shared/domains/common-ui';
export function KindField() {
    const [kindField, , kindHelpers] = useField('kind');
    const { value } = kindField;
    const { isFeatureAvailable } = useCompanyFeatures();
    const isApprovalWorkflowPromptsAvailable = isFeatureAvailable('document-assistant:workflows');
    const setKind = (kind) => {
        kindHelpers.setValue(kind);
        kindHelpers.setTouched(true);
    };
    return (<Box mb="xl" display="block">
      <ToggleTabs activeTab={value} onSelectTab={setKind}>
        <ToggleTabsButtonsContainer stretch size="small">
          <ToggleTabsButton tabKey={AssistantChatKind.Regular}>
            <Trans comment="Prompt library - Chat prompt tab">Chat prompt</Trans>
          </ToggleTabsButton>

          <ToggleTabsButton tabKey={AssistantChatKind.Tabular}>
            <Trans comment="Prompt library - Tabular review prompt tab">Tabular review prompt</Trans>
          </ToggleTabsButton>

          {isApprovalWorkflowPromptsAvailable && (<ToggleTabsButton tabKey={AssistantChatKind.ApprovalWorkflow}>
              <Trans comment="Prompt library - Approval workflow prompt tab">Approval workflow prompt</Trans>
            </ToggleTabsButton>)}
        </ToggleTabsButtonsContainer>
      </ToggleTabs>
    </Box>);
}
